import { useGetProfileImage } from '../../hooks';
import { COLORS } from '../../constants/style/color';
import { NavBarLabel, NavBarProfilePic } from './navbar.styled';
import Tooltip from '../tooltip';

interface NavLogoType {
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
  data?: any;
}

const NavLogo = ({ handleRequest, data }: NavLogoType): JSX.Element => {
  const { data: ProfileImage, isLoading, status } = useGetProfileImage(handleRequest);
  if (isLoading || status !== 'success') return <></>;
  return (
    <NavBarProfilePic>
      {(ProfileImage?.content as unknown as boolean) ? (
        <img
          src={`data:image/png;base64,${ProfileImage?.content ?? ''}`}
          alt={`${ProfileImage?.name ?? ''}`}
        />
      ) : (
        <Tooltip
          tooltipText={data?.holdingsData?.[0]?.companyName ?? ''}
          variant='dark'
          size='sm'
          placement='bottom-center'>
          <span>
            <NavBarLabel
              variant='h5'
              color={COLORS.DarkPurple}
              fontWeight={700}
              title={data?.holdingsData?.[0]?.companyName ?? ''}
            />
          </span>
        </Tooltip>
      )}
    </NavBarProfilePic>
  );
};

export { NavLogo };
